import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'vant/lib/index.css';
import { NumberKeyboard } from 'vant';
import { Loading } from 'vant';
import { ConfigProvider } from 'vant';

createApp(App).use(router).use(Loading).use(NumberKeyboard).use(ConfigProvider).mount('#app')
